import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HelperService } from 'src/app/services/helper.service';
import { AuthService } from 'src/app/services/auth.service';
import { CollaboratorService } from './../../../rest/api/collaborator.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login-collaborators',
  templateUrl: './login-collaborators.component.html',
  styleUrls: ['./login-collaborators.component.scss']
})
export class LoginCollaboratorsComponent implements OnInit {
  @Input() token;
  @Input() tokenData;
  form: FormGroup;

  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;
  errMessage: any;
  clientId: any;
  clientSecret: any;

  constructor(
    public fb: FormBuilder,
    public collaboratorService: CollaboratorService,
    public helperService: HelperService,
    private route: ActivatedRoute,
    public router: Router,
    public authService: AuthService
  ) {
    this.clientId = environment.clientId;
    this.clientSecret = environment.clientSecret;
  }

  ngOnInit() {
    this.initForm();
    this.authService.profileReceived.subscribe(this.profileReceived.bind(this));
    this.authService.profileError.subscribe(this.loginError.bind(this));
  }

  initForm() {
    this.form = this.fb.group({
      email: [{value: this.tokenData && this.tokenData.email ? this.tokenData.email : '', disabled: true},
        [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]],
    });
  }

  submit(value) {
    if (!this.form .valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.token = this.token;
    // data.clientId
    this.submitApi(data);
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  submitApi(data) {
    const formData = {
      username: this.tokenData.email,
      password: data.password,
      client_id: this.clientId,
      client_secret: this.clientSecret,
      grant_type: 'password',
      token: data.token
    };
    data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.loginCollaborator(data).subscribe((response: any) => {
      this.authService.profile(response);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.form.reset();
  }

  loginError(err) {
    this.isSubmitted = false;
    this.isSubmitting = false;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (err && err.status === 401) {
      this.errorMsg = 'Verify your account email address.';
      this.reset();
      setTimeout(() => {
        this.errorMsg = undefined;
      }, 5000);
    }

    if (err && err.error && err.error.errors) {
      this.errors = err.error.errors;
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    } else {
      this.errorMsg = 'Invalid email address / password.';
    }
  }

  reset() {
    this.form.reset();
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Unable to register at this time.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  profileReceived(res) {
    window.location.href = '/member/home';
  }

}
